import React, { useState, useEffect, useRef   } from "react";
import Accordion from "../Accordion";               // sube 1 nivel desde /AltaHistoriaClinica/
import DropzoneArchivos from "../../../../utils/DropzoneArchivos"; // ajusta si tu ruta real cambia
import CuestionarioPorEspecialidadHistoria from "./CuestionarioPorEspecialidadHistoria";
import {validarFormatoSistolica,validarFormatoDiastolica,validarRangoSistolica,normalizarEnterosistolicaOnBlur,
 validarRangoDiastolica,normalizarEnterodiastolicaOnBlur,validarFormatoPeso, validarDiastolicaNoMayorASistolica, validarSistolicaNoMenorADiastolica,
 validarRangoPeso,normalizarPesoOnBlur, validarFormatoAltura, validarRangoAltura,normalizarAlturaOnBlur, 
 validarFormatoFrecuenciaCardiaca,validarRangoFrecuenciaCardiaca,normalizarEnterofrecuenciacardiacaOnBlur, 
 validarFormatoFrecuenciaRespiratoria, validarRangoFrecuenciaRespiratoria,normalizarEnterofrecuenciarespiratoriaOnBlur,
 validarFormatoTemperatura, validarRangoTemperatura, normalizarTemperaturaOnBlur,  validarFormatoSaturacionOxigeno,
 validarRangoSaturacionOxigeno, normalizarEnterosaturacionOnBlur, validarFormatoCircunferenciaCintura, 
 normalizarEnteroCircunferenciaCinturaOnBlur, validarRangoCircunferenciaCintura, validarFormatoGlucemia, 
 normalizarEnteroGlucemiaOnBlur, validarRangoGlucemia,validarFechaConsultaNoFuturo, validarFechaConsultaNo48hAtras, validarFechaConsultaNoAntesNacimientoMenor48h,
 calcularEdadEnFechaConsulta,} from "../../../../utils/validaciones/expediente";
import {msgPresionSistolicaFueraRango,msgPresionDiastolicaFueraRango,msgDiastolicaMayorASistolica,
  msgFrecuenciaCardiacaFueraRango, msgFrecuenciaRespiratoriaFueraRango, msgSaturacionOxigenoFueraRango, 
  msgTemperaturaFueraRango, msgCircunferenciaCinturaFueraRango, msgGlucemiaFueraRango,
  msgAlturaFueraRango, msgPesoFueraRango, msgFechaConsultaFuturo, msgFechaConsulta48h, msgFechaConsultaAntesNacimiento,
  msgEdadRango,} from "../../../../utils/validaciones/mensajes";
import { toast } from "react-toastify";
import { getCatalogoDiagnosticos,  getSugerenciasHistoricasExpediente, } from "../../../../services/historiaClinica";
import { aplicaConfirmacionDiagnostica } from "../../../../utils/validaciones/elegibilidad";
import SwitchDesconocido from "../SwitchDesconocido";
import CampoAsistido from "../../../../utils/asistenciacaptura/campoasistido";

export default function HistoriaClinicaFormCommon({
  // estado y setters
  historia,
  setHistoria,
  uploadedFiles,
  setUploadedFiles,
  pacienteId,
  serviciosAtencion = [],
  aplicaUneme = false,
  diagnosticosSeleccionados,
  setDiagnosticosSeleccionados,

  // config y paciente (vienen del backend via AltaHistoriaClinica)
  cuestionarioConfig,
  nom024 = false,
  edadPaciente,
  edadMesesPaciente,
  sexo,
  fechaNacimiento,
  fechaNacimientoPrestador,
  
  // plantillas personalizadas
  plantillasHabilitadas = false,
  plantillasPersonalizadas = [],

  // sugerencias históricas
  sugerenciasHistoricasHabilitadas = true,
  onOcultarSugerenciaHistorica = null,

  // visibilidad acordeones
  openRubros,
  toggleRubro,

  // edición de fecha consulta
  isFechaEditable,
  toggleFechaEditable,

  // handlers de inputs
  handleChange,
  handleNestedChange,
  handleDeepNestedChange,

  // etiquetas
  etiquetasPersonalesPatologicos,
  etiquetasPersonalesNoPatologicos,

  // lógica de "Grupo Étnico → Otro..."
  showGrupoEtnicoOtro,
  setShowGrupoEtnicoOtro,
  
}) {
  const enabledEntry = Array.isArray(cuestionarioConfig?.historia)
  ? cuestionarioConfig.historia.find((s) => s && s.enabled)
  : null;

  const selectedKeys =
  Array.isArray(cuestionarioConfig?.custom?.historia?.selected_keys)
    ? new Set(cuestionarioConfig.custom.historia.selected_keys)
    : Array.isArray(cuestionarioConfig?.custom?.selected_keys)
    ? new Set(cuestionarioConfig.custom.selected_keys)
    : null;
  
  const captureModes = cuestionarioConfig?.custom?.historia?.capture_modes || {};
  
  const especialidadHistoria =
    enabledEntry?.key || null;
  
    // medicamentos

        const [medicamentos, setMedicamentos] = React.useState(
      Array.isArray(historia.medicamentos) && historia.medicamentos.length
        ? historia.medicamentos
        : [{ nombre: "", indicaciones: "" }]
      );

      React.useEffect(() => {
      setHistoria(prev => ({
        ...prev,
        medicamentos
      }));
    }, [medicamentos]);

 const [cieFields, setCieFields] = useState([1]);
 const [cieActivo, setCieActivo] = useState(1);
 const [diagnosticoBusqueda, setDiagnosticoBusqueda] = useState({
   1: "",
   2: "",
   3: ""
 });
 const [diagnosticosCatalogo, setDiagnosticosCatalogo] = useState([]);
 
 const fechaConsultaAnteriorRef = useRef(historia.fechaConsulta);
 
 
 useEffect(() => {
  if (!nom024) return;

  setHistoria((prev) => ({
    ...prev,
    primeraVezAnio: 1,
    primeraVezUneme: aplicaUneme ? prev.primeraVezUneme : -1,
  }));
}, [nom024, aplicaUneme, setHistoria]);

  

  useEffect(() => {
    const terminoBusqueda = diagnosticoBusqueda[cieActivo] || "";
    const codigoActivo = historia[`codigoCIEDiagnostico${cieActivo}`];
    const timer = setTimeout(async () => {
      // si ya hay diagnóstico seleccionado, no buscar más
      if (codigoActivo) {
             setDiagnosticosCatalogo([]);
        return;
      }
      if (!terminoBusqueda || terminoBusqueda.length < 2) {
            setDiagnosticosCatalogo([]);
        return;
      }

      if (nom024 && !historia.fechaConsulta) {
        setDiagnosticosCatalogo([]);
        return;
      }

      if (
        nom024 &&
        !["0", "1"].includes(String(historia.relacionTemporal).trim())
      ) {
        setDiagnosticosCatalogo([]);
        return;
      }

      const data = await getCatalogoDiagnosticos(
        terminoBusqueda,
        pacienteId,
        historia.relacionTemporal,
        historia.fechaConsulta,
        cieActivo
      );
      setDiagnosticosCatalogo(data);

      if (data.length === 0) {
        toast.warning(
          "Sin resultados. El término ingresado no coincide con ningún diagnóstico disponible para este paciente según los criterios de edad y sexo establecidos, o bien no existe en el catálogo. Intente con otro término.",
          { toastId: "dx-sin-resultados" }
        );
            
      }
    
      }, 300);

    return () => clearTimeout(timer);

}, [
  cieActivo,
  diagnosticoBusqueda,
  historia.relacionTemporal,
  historia.fechaConsulta,
  historia.codigoCIEDiagnostico1,
  historia.codigoCIEDiagnostico2,
  historia.codigoCIEDiagnostico3
]);

useEffect(() => {
   const visibles = [1];
   if (historia.codigoCIEDiagnostico2) visibles.push(2);
   if (historia.codigoCIEDiagnostico3) visibles.push(3);

   setCieFields((prev) => (prev.length >= visibles.length ? prev : visibles));
 }, [historia.codigoCIEDiagnostico2, historia.codigoCIEDiagnostico3]);

const agregarCampoCIE = () => {
  setCieFields((prev) => {
    if (prev.length >= 3) return prev;

    const siguiente = [1, 2, 3].find((n) => !prev.includes(n));
    if (!siguiente) return prev;

    if (siguiente !== 1) {
      setHistoria((h) => ({
        ...h,
       [`primeraVezDiagnostico${siguiente}`]: "",
        [`codigoCIEDiagnostico${siguiente}`]: "",
        [`confirmacionDiagnostica${siguiente}`]: null,
      }));
    }

    return [...prev, siguiente];
  });
};

  const eliminarCampoCIE = (num) => {
    const restantes = cieFields.filter((n) => n !== num);

    setHistoria({
  ...historia,
  [`codigoCIEDiagnostico${num}`]: "",
  [`primeraVezDiagnostico${num}`]: null,
  [`confirmacionDiagnostica${num}`]: null
});

    setDiagnosticosSeleccionados((prev) => ({
      ...prev,
      [num]: null
    }));

    setDiagnosticoBusqueda((prev) => ({
      ...prev,
      [num]: ""
    }));

    setDiagnosticosCatalogo([]);
   setCieFields(restantes.length ? restantes : [1]);

   if (cieActivo === num) {
     setCieActivo(restantes[0] || 1);
   }
 };

 useEffect(() => {
  if (!nom024) {
    fechaConsultaAnteriorRef.current = historia.fechaConsulta;
    return;
  }

  const fechaAnterior = fechaConsultaAnteriorRef.current;
  const fechaActual = historia.fechaConsulta;

  fechaConsultaAnteriorRef.current = fechaActual;

  if (!fechaAnterior || fechaAnterior === fechaActual) return;

  const hayCieSeleccionado =
    historia.codigoCIEDiagnostico1 ||
    historia.codigoCIEDiagnostico2 ||
    historia.codigoCIEDiagnostico3;

  if (!hayCieSeleccionado) return;

  setHistoria((prev) => ({
    ...prev,
    codigoCIEDiagnostico1: "",
    codigoCIEDiagnostico2: "",
    codigoCIEDiagnostico3: "",
    primeraVezDiagnostico2: null,
    primeraVezDiagnostico3: null,
    confirmacionDiagnostica1: null,
    confirmacionDiagnostica2: null,
    confirmacionDiagnostica3: null,
  }));

  setDiagnosticosSeleccionados({ 1: null, 2: null, 3: null });
  setDiagnosticoBusqueda({ 1: "", 2: "", 3: "" });
  setDiagnosticosCatalogo([]);
  setCieFields([1]);
  setCieActivo(1);

  toast.info("La fecha de consulta cambió. Vuelve a seleccionar el diagnóstico CIE para aplicar los filtros de edad correctos.");
}, [nom024, historia.fechaConsulta]);

  return (
    <>
<Accordion
          title="Antecedentes heredofamiliares"
          isOpen={openRubros["rubro-heredofam"]}
          onToggle={() => toggleRubro("rubro-heredofam")}
          anchorId="rubro-heredofam"
        >
          <div className="rubro">
            {/* Antecedentes Heredofamiliares */}
           
            {(captureModes.heredofamiliares || "detallado") === "detallado" ? (
              Object.keys(historia.antecedentes.heredoFamiliares).map((key) => (
                <div key={key} className="subrubro">
                  <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                  
                  <CampoAsistido
                    campo={`heredofamiliares_${key}`}
                    name={key}
                    placeholder={`Ingrese antecedentes de salud de ${key}`}
                    value={historia.antecedentes.heredoFamiliares[key] || ""}
                    onChange={(e) =>
                      handleDeepNestedChange(e, "heredoFamiliares", key)
                    }
                    plantillasHabilitadas={plantillasHabilitadas}
                    plantillasPersonalizadas={plantillasPersonalizadas}
                  />
                </div>
              ))
            ) : (
              <div className="subrubro">
                <CampoAsistido
                  tipo="textarea"
                  campo="heredofamiliares_consolidado"
                  name="heredofamiliares_consolidado"
                  placeholder="Ingrese los antecedentes heredofamiliares del paciente"
                  value={historia.heredofamiliares_consolidado || ""}
                  onChange={handleChange}
                  plantillasHabilitadas={plantillasHabilitadas}
                  plantillasPersonalizadas={plantillasPersonalizadas}
                />
              </div>
            )}
          </div>
        </Accordion>
        <Accordion
          title="Antecedentes personales no patológicos"
          isOpen={openRubros["rubro-no-pat"]}
          onToggle={() => toggleRubro("rubro-no-pat")}
          anchorId="rubro-no-pat"
        >
        <div className="rubro">
          {/* Antecedentes Personales No Patológicos */}
          {(captureModes.no_patologicos || "detallado") === "detallado" ? (
            Object.keys(historia.antecedentes.personalesNoPatologicos).map((key) => (
              <div key={key} className="subrubro">
                <label>{etiquetasPersonalesNoPatologicos[key] || key.charAt(0).toUpperCase() + key.slice(1)}</label>

                <CampoAsistido
                  campo={`no_patologicos_${String(key).toLowerCase()}`}
                  name={key}
                  placeholder={`Ingrese ${
                    etiquetasPersonalesNoPatologicos[key] ||
                    key.charAt(0).toUpperCase() + key.slice(1)
                  }`}
                  value={
                    historia.antecedentes.personalesNoPatologicos[key] || ""
                  }
                  onChange={(e) =>
                    handleDeepNestedChange(e, "personalesNoPatologicos", key)
                  }
                  plantillasHabilitadas={plantillasHabilitadas}
                  plantillasPersonalizadas={plantillasPersonalizadas}
                />
              </div>
            ))
          ) : (
            <div className="subrubro">
              <CampoAsistido
                tipo="textarea"
                campo="no_patologicos_consolidado"
                name="no_patologicos_consolidado"
                placeholder="Ingrese los antecedentes personales no patológicos del paciente: Origen, ocupación, escolaridad, religión, mascotas, viajes, alimentación, vivienda."
                value={historia.no_patologicos_consolidado || ""}
                onChange={handleChange}
                plantillasHabilitadas={plantillasHabilitadas}
                plantillasPersonalizadas={plantillasPersonalizadas}
              />
            </div>
          )}
          <label>Grupo Étnico</label>
            <select
              value={showGrupoEtnicoOtro ? "__OTRO__" : (historia.grupo_etnico || "")}
              onChange={(e) => {
                const v = e.target.value;
                if (v === "__OTRO__") {
                  setShowGrupoEtnicoOtro(true);
                  setHistoria(h => ({ ...h, grupo_etnico: "" }));
                } else {
                  setShowGrupoEtnicoOtro(false);
                  setHistoria(h => ({ ...h, grupo_etnico: v }));
                }
              }}
            >
              <option value="">Seleccione</option>
              <option value="Indígena">Indígena</option>
              <option value="Afrodescendiente">Afrodescendiente</option>
              <option value="Mestizo">Mestizo</option>
              <option value="Ninguno / No especifica">Ninguno / No especifica</option>
              <option value="__OTRO__">Otro…</option>
            </select>

            {showGrupoEtnicoOtro && (
              <>
                <label>Especifique grupo étnico</label>
                <input
                  name="grupo_etnico"
                  value={historia.grupo_etnico}
                  onChange={handleChange}
                  placeholder="Ej. Náhuatl, Maya, Mixe, etc."
                />
              </>
            )}
        </div>
      </Accordion>
      <Accordion
        title="Antecedentes personales patológicos"
        isOpen={openRubros["rubro-pat"]}
        onToggle={() => toggleRubro("rubro-pat")}
        anchorId="rubro-pat"
      >
        <div className="rubro">
          {/* Antecedentes Personales Patológicos */}
             {/* ECD — siempre visible */}
          <div className="subrubro">
            <label>{etiquetasPersonalesPatologicos?.ECD || "Enfermedades crónico-degenerativas"}</label>
             <CampoAsistido
            tipo="textarea"
            campo="patologicos_ECD"
            name="ECD"
            placeholder="Ingrese enfermedades crónico degenerativas"
            value={historia.antecedentes.personalesPatologicos.ECD || ""}
            onChange={(e) =>
              handleDeepNestedChange(e, "personalesPatologicos", "ECD")
            }
            plantillasHabilitadas={plantillasHabilitadas}
            plantillasPersonalizadas={plantillasPersonalizadas}
          />
          </div>

          {/* Alergias — siempre visible */}
          <div className="subrubro">
            <label>{etiquetasPersonalesPatologicos?.alergias || "Alergias"}</label>
            <CampoAsistido
              campo="patologicos_alergias"
              name="alergias"
              placeholder="Ingrese alergias"
              value={historia.antecedentes.personalesPatologicos.alergias || ""}
              onChange={(e) =>
                handleDeepNestedChange(e, "personalesPatologicos", "alergias")
              }
              plantillasHabilitadas={plantillasHabilitadas}
              plantillasPersonalizadas={plantillasPersonalizadas}
            />
          </div>

          {/* Hemotipo — siempre visible */}
          <div className="subrubro">
            <label>Hemotipo</label>
            <select
              name="hemotipo"
              value={historia.antecedentes.personalesPatologicos.hemotipo || ""}
              onChange={(e) => handleDeepNestedChange(e, "personalesPatologicos", "hemotipo")}
            >
              <option value="">Seleccione</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
              <option value="desconoce">Desconoce</option>
            </select>
          </div>

          {/* Resto — consolidado o detallado */}
         {(captureModes.patologicos || "detallado") === "detallado" ? (
            Object.keys(historia.antecedentes.personalesPatologicos)
              .filter((key) => !["ECD", "alergias", "hemotipo"].includes(key))
              .map((key) => (
                <div key={key} className="subrubro">
                  <label>
                    {etiquetasPersonalesPatologicos[key] ||
                      key.charAt(0).toUpperCase() + key.slice(1)}
                  </label>

                  <CampoAsistido
                    campo={`patologicos_${key}`}
                    name={key}
                    placeholder={`Ingrese ${
                      etiquetasPersonalesPatologicos[key] ||
                      key.charAt(0).toUpperCase() + key.slice(1)
                    }`}
                    value={historia.antecedentes.personalesPatologicos[key] || ""}
                    onChange={(e) =>
                      handleDeepNestedChange(e, "personalesPatologicos", key)
                    }
                    plantillasHabilitadas={plantillasHabilitadas}
                    plantillasPersonalizadas={plantillasPersonalizadas}
                  />
                </div>
              ))
          ) : (
            <div className="subrubro">
              <label>Otros antecedentes patológicos</label>
              
              <CampoAsistido
                tipo="textarea"
                campo="patologicos_consolidado"
                name="patologicos_consolidado"
                placeholder="Ingrese otros antecedentes patológicos: Quirúrgicos, traumáticos, hospitalizaciones, infectocontagiosos, transfusionales, exantemáticos, alcohol, tabaco, toxicomanías, vacunación, gineco-obstétricos/andrológicos, otros"
                value={historia.patologicos_consolidado || ""}
                onChange={handleChange}
                plantillasHabilitadas={plantillasHabilitadas}
                plantillasPersonalizadas={plantillasPersonalizadas}
              />
            </div>
          )} 
        </div>
      </Accordion>
      
      <Accordion
          title="Datos de la consulta"
          isOpen={openRubros["rubro-consulta"]}
          onToggle={() => toggleRubro("rubro-consulta")}
          anchorId="rubro-consulta"
        >
          <div className="rubro">
            {/* Fecha y hora de la consulta */}
            <label>Fecha y Hora de la Consulta*</label>
            <div className="fecha-consulta-wrapper">
              <input
                type="datetime-local"
                name="fechaConsulta"
                value={historia.fechaConsulta}
                onChange={handleChange}
                onBlur={(e) => {
                  if (!nom024) return;

                  const now = new Date();
                  const resetFecha = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
                    .toISOString()
                    .slice(0, 16);

                  const fechaCapturada = String(e.target.value || "").trim();

                  if (!fechaCapturada) return;

                  if (!validarFechaConsultaNoFuturo(fechaCapturada)) {
                    msgFechaConsultaFuturo();
                    setHistoria(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }

                  if (!validarFechaConsultaNo48hAtras(fechaCapturada)) {
                    msgFechaConsulta48h();
                    setHistoria(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }

                  if (!validarFechaConsultaNoAntesNacimientoMenor48h(fechaCapturada, fechaNacimiento)) {
                    msgFechaConsultaAntesNacimiento();
                    setHistoria(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }
                  
                   // Validar edad mínima del prestador en la fecha de consulta
                  const edadPrestadorEnFechaConsulta = calcularEdadEnFechaConsulta(
                    fechaNacimientoPrestador,
                    fechaCapturada
                  );

                  if (
                    edadPrestadorEnFechaConsulta !== null &&
                    edadPrestadorEnFechaConsulta < 18
                  ) {
                    msgEdadRango();
                    setHistoria(prev => ({ ...prev, fechaConsulta: resetFecha }));
                    return;
                  }
                }}
                disabled={!isFechaEditable}
                required
              />
              <button type="button" className="editar-fecha-button" onClick={toggleFechaEditable}>
                {isFechaEditable ? "Bloquear" : "Editar"}
              </button>
            </div>
          </div>

          <div className="rubro">
            {/* Tipo de interrogatorio */}
            <label>Tipo de Interrogatorio</label>
            <select 
              name="tipoInterrogatorio" 
              value={historia.tipoInterrogatorio} 
              onChange={handleChange} 
              
            >
              <option value="">Seleccione</option>
              <option value="Directo">Directo</option>
              <option value="Indirecto">Indirecto</option>
              <option value="Mixto">Mixto</option>
            </select>
          </div>
          {nom024 && (
          <div className="rubro">
            <label>Servicio de atención*</label>
            <select
              name="servicioAtencion"
              value={historia.servicioAtencion ?? ""}
              onChange={handleChange}
            >
              <option value="">Seleccione</option>
              {serviciosAtencion.map((s) => (
                <option key={s.CATALOG_KEY} value={s.CATALOG_KEY}>
                  {s.SERVICIOS_ATENCION}
                </option>
              ))}
            </select>
          </div>
           )}

           {nom024 && aplicaUneme && (
            <div className="rubro">
              <label>¿Primera vez en UNEME?</label>
              <select
                name="primeraVezUneme"
                value={historia.primeraVezUneme ?? ""}
                onChange={(e) =>
                  setHistoria((prev) => ({
                    ...prev,
                    primeraVezUneme: e.target.value === "" ? null : Number(e.target.value),
                  }))
                }
              >
                <option value="">Seleccione</option>
                <option value="0">No</option>
                <option value="1">Sí</option>
              </select>
            </div>
          )}
          
        </Accordion>
      <Accordion
        title="Interrogatorio"
        isOpen={openRubros["rubro-aparatos"]}
        onToggle={() => toggleRubro("rubro-aparatos")}
        anchorId="rubro-aparatos"
      >
        <div className="rubro">
       
            {/* Padecimiento actual */}
          <h3>Padecimiento Actual</h3>
          <textarea
            name="padecimientoActual"
            placeholder="Describa el padecimiento actual"
            value={historia.padecimientoActual}
            onChange={handleChange}
            
          ></textarea>
          {nom024 && (
          <div className="subrubro">
            <label>¿Paciente sintomático respiratorio sospechoso de Tuberculosis Pulmonar?</label>
            <select
              name="sintomaticoRespiratorioTb"
              value={historia.sintomaticoRespiratorioTb ?? "-1"}
              onChange={handleChange}
            >
              <option value="-1">Seleccione</option>
              <option value="0">No</option>
              <option value="1">Sí</option>
            </select>
          </div>
          )}
           <h3>Interrogatorio por aparatos y sistemas</h3>
          {(captureModes.interrogatorio || "detallado") === "detallado" ? (
            [
              { name: "sistema_nervioso",           label: "Sistema nervioso" },
              { name: "sistema_cardiovascular",     label: "Sistema cardiovascular" },
              { name: "sistema_respiratorio",       label: "Sistema respiratorio" },
              { name: "sistema_digestivo",          label: "Sistema digestivo" },
              { name: "sistema_genitourinario",     label: "Sistema genitourinario" },
              { name: "sistema_musculoesqueletico", label: "Sistema musculoesquelético" },
              { name: "sistema_endocrino",          label: "Sistema endocrino" },
              { name: "sistema_hematologico",       label: "Sistema hematológico" },
              { name: "piel_anexos",                label: "Piel y anexos" },
            ].map(({ name, label }) => (
              <div className="subrubro" key={name}>
                <label>{label}</label>
                <CampoAsistido
                  campo={name}
                  placeholder={`Ingrese ${label.toLowerCase()}`}
                  value={historia[name] || ""}
                  onChange={handleChange}
                  plantillasHabilitadas={plantillasHabilitadas}
                  plantillasPersonalizadas={plantillasPersonalizadas}
                />
              </div>
            ))
          ) : (
            <div className="subrubro">
              <CampoAsistido
                tipo="textarea"
                campo="interrogatorio_consolidado"
                placeholder="Ingrese interrogatorio por aparatos y sistemas: sistema nervioso, cardiovascular, respiratorio, digestivo, genitourinario, musculoesquelético, endocrino, hematológico, piel y anexos"
                value={historia.interrogatorio_consolidado || ""}
                onChange={handleChange}
                plantillasHabilitadas={plantillasHabilitadas}
                plantillasPersonalizadas={plantillasPersonalizadas}
              />
            </div>
          )}
        </div>
      </Accordion>

        
      
        
      <Accordion
        title="Exploración física"
        isOpen={openRubros["rubro-exploracion"]}
        onToggle={() => toggleRubro("rubro-exploracion")}
        anchorId="rubro-exploracion"
      >
        <div className="rubro">
          {/* Exploración física */}
          <h3>Exploración Física</h3>
          <CampoAsistido
              tipo="textarea"
              campo="exploracion_fisica"
              name="otros"
              placeholder="Ingrese exploración física"
              value={historia.exploracionFisica.otros || ""}
              onChange={(e) => handleNestedChange(e, "exploracionFisica")}
              plantillasHabilitadas={plantillasHabilitadas}
              plantillasPersonalizadas={plantillasPersonalizadas}
            />
          
          <div className="pa-wrapper">
          <h3>Signos Vitales</h3>
          <label>Presión Arterial (mmHg)</label>
          {nom024 && (
          <SwitchDesconocido
              prendido={
                historia.exploracionFisica.signosVitales.sistolica === "0" ||
                historia.exploracionFisica.signosVitales.diastolica === "0"
              }
              onCambio={(prendido) => setHistoria({
                ...historia,
                exploracionFisica: {
                  ...historia.exploracionFisica,
                  signosVitales: {
                    ...historia.exploracionFisica.signosVitales,
                    sistolica: prendido ? "0" : "",
                    diastolica: prendido ? "0" : ""
                  }
                }
              })}
            />)}
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <input
              type="text"
              name="sistolica"
              placeholder="Ej: 120"
              value={historia.exploracionFisica.signosVitales.sistolica}
              maxLength={3}
              disabled={historia.exploracionFisica.signosVitales.diastolica === "0"}
              onChange={(e) => {
                let value = e.target.value;

                // permitir vacío
                if (value === "") {
                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        sistolica: value
                      }
                    }
                  });
                  return;
                }

                // solo números
                if (!validarFormatoSistolica(value)) return;

                setHistoria({
                  ...historia,
                  exploracionFisica: {
                    ...historia.exploracionFisica,
                    signosVitales: {
                      ...historia.exploracionFisica.signosVitales,
                      sistolica: value
                    }
                  }
                });
              }}
              onBlur={(e) => {
                const value = e.target.value;
                if (value === "") return;

                const normalizado = normalizarEnterosistolicaOnBlur(value);
                const diastolicaActual = historia.exploracionFisica.signosVitales.diastolica;

                if (!validarRangoSistolica(value)) {
                  msgPresionSistolicaFueraRango();

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        sistolica: ""
                      }
                    }
                  });
                } else if (!validarSistolicaNoMenorADiastolica(normalizado, diastolicaActual)) {
                  msgDiastolicaMayorASistolica();

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        sistolica: ""
                      }
                    }
                  });
                } else {
                 e.target.value = normalizado;
                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        sistolica: normalizado,
                        ...(normalizado === "0" ? { diastolica: "0" } : {})
                      }
                    }
                  });
                }
              }}
            />

            <span>/</span>

            <input
              type="text"
              name="diastolica"
              placeholder="Ej: 80"
              value={historia.exploracionFisica.signosVitales.diastolica}
              maxLength={3}
              disabled={historia.exploracionFisica.signosVitales.sistolica === "0"}
              onChange={(e) => {
                let value = e.target.value;

                // permitir vacío
                if (value === "") {
                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        diastolica: value
                      }
                    }
                  });
                  return;
                }

                // solo números
                if (!validarFormatoDiastolica(value)) return;

                setHistoria({
                  ...historia,
                  exploracionFisica: {
                    ...historia.exploracionFisica,
                    signosVitales: {
                      ...historia.exploracionFisica.signosVitales,
                      diastolica: value
                    }
                  }
                });
              }}
              onBlur={(e) => {
                const value = e.target.value;
                if (value === "") return;

                const normalizado = normalizarEnterodiastolicaOnBlur(value);
                const sistolicaActual = historia.exploracionFisica.signosVitales.sistolica;

                if (!validarRangoDiastolica(value)) {
                  msgPresionDiastolicaFueraRango();

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        diastolica: ""
                      }
                    }
                  });
                } else if (!validarDiastolicaNoMayorASistolica(sistolicaActual, normalizado)) {
                  msgDiastolicaMayorASistolica();

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        diastolica: ""
                      }
                    }
                  });
                } else {
                 e.target.value = normalizado;
                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        diastolica: normalizado,
                        ...(normalizado === "0" ? { sistolica: "0" } : {})
                      }
                    }
                  });
                }
              }}
            />
          </div>

           <label>Frecuencia Cardiaca (lpm)</label>
              <input
                type="text"
                name="frecuenciaCardiaca"
                placeholder="Ej: 70"
                value={historia.exploracionFisica.signosVitales.frecuenciaCardiaca}
                maxLength={3}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === "") {
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          frecuenciaCardiaca: value
                        }
                      }
                    });
                    return;
                  }

                  if (!validarFormatoFrecuenciaCardiaca(value)) return;

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        frecuenciaCardiaca: value
                      }
                    }
                  });
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value === "") return;

                  const normalizado = normalizarEnterofrecuenciacardiacaOnBlur(value);

                  if (!validarRangoFrecuenciaCardiaca(value)) {
                    msgFrecuenciaCardiacaFueraRango();

                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          frecuenciaCardiaca: ""
                        }
                      }
                    });
                  } else {
                    e.target.value = normalizado;
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          frecuenciaCardiaca: normalizado
                        }
                      }
                    });
                  }
                }}
              />
            <label>Frecuencia Respiratoria (rpm)</label>
              <input
                type="text"
                name="frecuenciaRespiratoria"
                placeholder="Ej: 16"
                value={historia.exploracionFisica.signosVitales.frecuenciaRespiratoria}
                maxLength={2}
                onChange={(e) => {
                  const value = e.target.value;

                  // permitir vacío
                  if (value === "") {
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          frecuenciaRespiratoria: value
                        }
                      }
                    });
                    return;
                  }

                  if (!validarFormatoFrecuenciaRespiratoria(value)) return;

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        frecuenciaRespiratoria: value
                      }
                    }
                  });
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value === "") return;

                  const normalizado = normalizarEnterofrecuenciarespiratoriaOnBlur(value);

                  if (!validarRangoFrecuenciaRespiratoria(value)) {
                    msgFrecuenciaRespiratoriaFueraRango();

                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          frecuenciaRespiratoria: ""
                        }
                      }
                    });
                  } else {
                    e.target.value = normalizado;
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          frecuenciaRespiratoria: normalizado
                        }
                      }
                    });
                  }
                }}
              />
            <label>Temperatura (°C)</label>
              <input
                type="text"
                name="temperatura"
                placeholder="Ej: 36.5"
                value={historia.exploracionFisica.signosVitales.temperatura}
                maxLength={4}
                onChange={(e) => {
                  const value = e.target.value;

                  // permitir vacío
                  if (value === "") {
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          temperatura: value
                        }
                      }
                    });
                    return;
                  }

                  // validar formato
                  if (!validarFormatoTemperatura(value)) return;

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        temperatura: value
                      }
                    }
                  });
                }}
                onBlur={(e) => {
                  const value = e.target.value;

                  if (value === "") return;

                  const normalizado = normalizarTemperaturaOnBlur(value);

                  if (!validarRangoTemperatura(normalizado)) {
                    msgTemperaturaFueraRango();

                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          temperatura: ""
                        }
                      }
                    });
                  } else {
                    e.target.value = normalizado;

                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          temperatura: normalizado
                        }
                      }
                    });
                  }
                }}
              />
            <label>Saturación de Oxígeno (%)</label>
              <input
                type="text"
                name="saturacionOxigeno"
                placeholder="Ej: 98"
                value={historia.exploracionFisica.signosVitales.saturacionOxigeno}
                maxLength={3}
                onChange={(e) => {
                  const value = e.target.value;

                  // permitir vacío
                  if (value === "") {
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          saturacionOxigeno: value
                        }
                      }
                    });
                    return;
                  }

                  if (!validarFormatoSaturacionOxigeno(value)) return;

                  setHistoria({
                    ...historia,
                    exploracionFisica: {
                      ...historia.exploracionFisica,
                      signosVitales: {
                        ...historia.exploracionFisica.signosVitales,
                        saturacionOxigeno: value
                      }
                    }
                  });
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value === "") return;

                  const normalizado = normalizarEnterosaturacionOnBlur(value);

                  if (!validarRangoSaturacionOxigeno(value)) {
                    msgSaturacionOxigenoFueraRango();

                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          saturacionOxigeno: ""
                        }
                      }
                    });
                  } else {
                    e.target.value = normalizado;
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          saturacionOxigeno: normalizado
                        }
                      }
                    });
                  }
                }}
              />
              
          {nom024 && (<div className="subrubro" style={{ marginTop: "12px" }}>
            <h3>Metabólico</h3>
            <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span>¿Se realizó medición de glucosa?</span>
              </label>
              <span style={{ fontSize: "12px", color: "#6b7280" }}>No / Sí</span>
              
              <label className="switch">
                <input
                  type="checkbox"
                  checked={historia.exploracionFisica.signosVitales.glucosaMedida || false}
                  onChange={(e) => {
                    const activar = e.target.checked;

                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          glucosaMedida: activar,
                          glucemia: activar
                            ? historia.exploracionFisica.signosVitales.glucemia === "0"
                              ? ""
                              : historia.exploracionFisica.signosVitales.glucemia
                            : "0",
                          tipoMedicion: activar ? historia.exploracionFisica.signosVitales.tipoMedicion : "-1",
                          resultadoObtenidoaTravesde: activar ? historia.exploracionFisica.signosVitales.resultadoObtenidoaTravesde : "-1"
                        }
                      }
                    });
                  }}
                />
                <span className="slider"></span>
              </label>
                          

            {historia.exploracionFisica.signosVitales.glucosaMedida && (
              <>
                <label>Glucemia (mg/dl)</label>
                <input
                  type="text"
                  name="glucemia"
                  placeholder="Ej: 95"
                  value={historia.exploracionFisica.signosVitales.glucemia || ""}
                  maxLength={3}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "") {
                      setHistoria({
                        ...historia,
                        exploracionFisica: {
                          ...historia.exploracionFisica,
                          signosVitales: {
                            ...historia.exploracionFisica.signosVitales,
                            glucemia: value
                          }
                        }
                      });
                      return;
                    }

                    if (!validarFormatoGlucemia(value)) return;

                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          glucemia: value
                        }
                      }
                    });
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    if (value === "") return;

                    const normalizado = normalizarEnteroGlucemiaOnBlur(value);

                      if (
                        historia.exploracionFisica.signosVitales.glucosaMedida &&
                        normalizado === "0"
                      ) {
                        msgGlucemiaFueraRango();

                        setHistoria({
                          ...historia,
                          exploracionFisica: {
                            ...historia.exploracionFisica,
                            signosVitales: {
                              ...historia.exploracionFisica.signosVitales,
                              glucemia: ""
                            }
                          }
                        });

                        return;
                      }

                      if (!validarRangoGlucemia(value)) {
                        msgGlucemiaFueraRango();

                        setHistoria({
                          ...historia,
                          exploracionFisica: {
                            ...historia.exploracionFisica,
                            signosVitales: {
                              ...historia.exploracionFisica.signosVitales,
                              glucemia: ""
                            }
                          }
                        });
                      } else {
                      e.target.value = normalizado;

                      setHistoria({
                        ...historia,
                        exploracionFisica: {
                          ...historia.exploracionFisica,
                          signosVitales: {
                            ...historia.exploracionFisica.signosVitales,
                            glucemia: normalizado
                          }
                        }
                      });
                    }
                  }}
                />
                {historia.exploracionFisica.signosVitales.glucemia &&
                historia.exploracionFisica.signosVitales.glucemia !== "0" && (
                  <>
                <label>¿La medición fue en ayunas?</label>
                <select
                  name="tipoMedicion"
                  value={historia.exploracionFisica.signosVitales.tipoMedicion || "-1"}
                  onChange={(e) => {
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          tipoMedicion: e.target.value
                        }
                      }
                    });
                  }}
                >
                  <option value="-1">Seleccione</option>
                  <option value="0">No</option>
                  <option value="1">Sí</option>
                </select>

                <label>Origen del resultado</label>
                <select
                  name="resultadoObtenidoaTravesde"
                  value={historia.exploracionFisica.signosVitales.resultadoObtenidoaTravesde || "-1"}
                  onChange={(e) => {
                    setHistoria({
                      ...historia,
                      exploracionFisica: {
                        ...historia.exploracionFisica,
                        signosVitales: {
                          ...historia.exploracionFisica.signosVitales,
                          resultadoObtenidoaTravesde: e.target.value
                        }
                      }
                    });
                  }}
                >
                  <option value="-1">Seleccione</option>
                  <option value="1">Laboratorio</option>
                  <option value="2">Tira de glucosa capilar</option>
                </select>
              </>
              )}
              </>
            )}
          </div>
          )}
        </div>
          <h3>Somatometría</h3>
          <label>Peso (kg)</label>
            {nom024 && (<SwitchDesconocido
            prendido={historia.exploracionFisica.peso === "999"}
            onCambio={(prendido) => setHistoria({
              ...historia,
              exploracionFisica: {
                ...historia.exploracionFisica,
                peso: prendido ? "999" : ""
              }
            })}
          />)}
          <input
            type="text"
            name="peso"
            placeholder="Ej: 70"
            value={historia.exploracionFisica.peso}
            maxLength={7}
            disabled={historia.exploracionFisica.peso === "999"}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                handleNestedChange(e, "exploracionFisica");
                return;
              }
              if (!validarFormatoPeso(value)) return;
              handleNestedChange(e, "exploracionFisica");
            }}
            onBlur={(e) => {
              const value = e.target.value;
              if (value === "") return;

              const normalizado = normalizarPesoOnBlur(value);

              if (!validarRangoPeso(normalizado)) {
                msgPesoFueraRango();
                setHistoria({
                  ...historia,
                  exploracionFisica: { ...historia.exploracionFisica, peso: "" }
                });
              } else {
                e.target.value = normalizado;
                setHistoria({
                  ...historia,
                  exploracionFisica: { ...historia.exploracionFisica, peso: normalizado }
                });
              }
            }}
          />
          
         <label>Talla (m)</label>
          {nom024 && (<SwitchDesconocido
            prendido={historia.exploracionFisica.altura === "999"}
            onCambio={(prendido) => setHistoria({
              ...historia,
              exploracionFisica: {
                ...historia.exploracionFisica,
                altura: prendido ? "999" : ""
              }
            })}
          />)}
          <input
            type="text"
            name="altura"
            placeholder="Ej: 1.75"
            value={historia.exploracionFisica.altura}
            maxLength={5}
            disabled={historia.exploracionFisica.altura === "999"}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                handleNestedChange(e, "exploracionFisica");
                return;
              }
              if (!validarFormatoAltura(value)) return;
              handleNestedChange(e, "exploracionFisica");
            }}
            onBlur={(e) => {
              const value = e.target.value;
              if (value === "") return;

              const normalizado = normalizarAlturaOnBlur(value);

              if (!validarRangoAltura(normalizado)) {
                msgAlturaFueraRango();
                setHistoria({
                  ...historia,
                  exploracionFisica: { ...historia.exploracionFisica, altura: "" }
                });
              } else {
                e.target.value = normalizado;
                setHistoria({
                  ...historia,
                  exploracionFisica: { ...historia.exploracionFisica, altura: normalizado }
                });
              }
            }}
          />
             {nom024 && (
            <>
            <label>Circunferencia de cintura (cm)</label>
              <input
                type="text"
                name="circunferenciaCintura"
                placeholder="Ej: 85"
                value={historia.exploracionFisica.circunferenciaCintura || ""}
                maxLength={3}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    handleNestedChange(e, "exploracionFisica");
                    return;
                  }
                  if (!validarFormatoCircunferenciaCintura(value)) return;
                  handleNestedChange(e, "exploracionFisica");
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value === "") return;

                  const normalizado = normalizarEnteroCircunferenciaCinturaOnBlur(value);

                  if (!validarRangoCircunferenciaCintura(normalizado)) {
                    msgCircunferenciaCinturaFueraRango();
                    setHistoria({
                      ...historia,
                      exploracionFisica: { ...historia.exploracionFisica, circunferenciaCintura: "" }
                    });
                  } else {
                    e.target.value = normalizado;
                    setHistoria({
                      ...historia,
                      exploracionFisica: { ...historia.exploracionFisica, circunferenciaCintura: normalizado }
                    });
                  }
                }}
              />            
            </>
            )}
         <label>IMC</label>
          <input
            type="number"
            step="0.01"
            name="imc"
            value={historia.imc}
            readOnly
            disabled
          />

          <label>Categoría IMC</label>
          <input
            name="categoria_imc"
            value={historia.categoria_imc}
            readOnly
            disabled
          />
         
        </div>
      </Accordion>
      <Accordion
        title="Estudios"
        isOpen={openRubros["rubro-estudios"]}
        onToggle={() => toggleRubro("rubro-estudios")}
        anchorId="rubro-estudios"
      >
        <div className="rubro">
          <h3>Estudios de laboratorio y gabinete</h3>
          
          <textarea
            name="laboratorios_texto"
            placeholder="Ingrese estudios de laboratorios y gabinete"
            value={historia.laboratorios_texto}
            onChange={handleChange}
          />

          <DropzoneArchivos
            onFilesSelected={(files) => setUploadedFiles(files)}
            archivosSeleccionados={uploadedFiles}
          />
        </div>
      </Accordion>
      <Accordion
        title="Diagnóstico, pronóstico y plan de tratamiento"
        isOpen={openRubros["rubro-dx-plan"]}
        onToggle={() => toggleRubro("rubro-dx-plan")}
        anchorId="rubro-dx-plan"
      >
        <div className="rubro">
          {/* Diagnósticos */}
          <h3>Diagnósticos</h3>
          
           {nom024 && (
         <>
         <div className="subrubro" style={{ marginTop: 8 }}>
          <label>Relación temporal del diagnóstico principal*</label>
          <select
            name="relacionTemporal"
            value={historia.relacionTemporal ?? ""}
            onChange={(e) => {
              const nuevoValor = e.target.value === "" ? null : Number(e.target.value);

              setHistoria((prev) => ({
                ...prev,
                relacionTemporal: nuevoValor,
                codigoCIEDiagnostico1: "",
                codigoCIEDiagnostico2: "",
                codigoCIEDiagnostico3: "",
                primeraVezDiagnostico2: null,
                primeraVezDiagnostico3: null,
                confirmacionDiagnostica1: null,
                confirmacionDiagnostica2: null,
                confirmacionDiagnostica3: null,
              }));

              setDiagnosticosSeleccionados({ 1: null, 2: null, 3: null });
              setDiagnosticoBusqueda({ 1: "", 2: "", 3: "" });
              setDiagnosticosCatalogo([]);
              setCieFields([1]);
              setCieActivo(1);
            }}
          >
            <option value="">Seleccione</option>
            <option value="0">Primera vez</option>
            <option value="1">Subsecuente</option>
          </select>
        </div>
         {cieFields.map((num) => (
  <div key={num} style={{ marginBottom: 12 }}>
    {num !== 1 && (
      <div className="subrubro" style={{ marginTop: 8 }}>
        <label>
          ¿Es primera vez del diagnóstico {num}?
        </label>

        <select
          name={`primeraVezDiagnostico${num}`}
          value={historia[`primeraVezDiagnostico${num}`] ?? ""}
          onChange={(e) =>
            setHistoria((prev) => ({
              ...prev,
              [`primeraVezDiagnostico${num}`]:
                e.target.value === "" ? "" : Number(e.target.value),
              [`codigoCIEDiagnostico${num}`]: "",
              [`confirmacionDiagnostica${num}`]: null,
            }))
          }
        >
          <option value="">Seleccione</option>
          <option value="1">Sí</option>
          <option value="0">No</option>
        </select>
      </div>
    )}

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr auto",
        gap: 8,
        marginBottom: 8,
        alignItems: "start"
      }}
    >
      <div className="cie-autocomplete">
                <input
                  type="text"
                  placeholder="Escribe el diagnostico y escoge el CIE correcto*."
                  value={diagnosticoBusqueda[num]}
                  onFocus={() => {
                     if (nom024 && !historia.fechaConsulta) {
                        toast.error("Primero seleccione la fecha de consulta.");
                        return;
                      }
                    if (
                      nom024 &&
                      !["0", "1"].includes(String(historia.relacionTemporal).trim())
                    ) {
                      toast.error("Primero seleccione la relación temporal del diagnóstico principal.");
                      return;
                    }

                     if (
                        nom024 &&
                        num !== 1 &&
                        !["0", "1"].includes(String(historia[`primeraVezDiagnostico${num}`]).trim())
                      ) {
                        toast.error(`Primero indique si el diagnóstico ${num} es de primera vez.`);
                        return;
                      }

                    setCieActivo(num);
                  }}
                  onChange={(e) => {
                     if (nom024 && !historia.fechaConsulta) {
                      toast.error("Primero seleccione la fecha de consulta.");
                      return;
                    }
                    if (
                        nom024 &&
                        !["0", "1"].includes(String(historia.relacionTemporal).trim())
                      ) {
                        toast.error("Primero seleccione la relación temporal del diagnóstico principal.");
                        return;
                      }

                      if (
                          nom024 &&
                          num !== 1 &&
                          !["0", "1"].includes(String(historia[`primeraVezDiagnostico${num}`]).trim())
                        ) {
                          toast.error(`Primero indique si el diagnóstico ${num} es de primera vez.`);
                          return;
                        }
                    const value = e.target.value.toUpperCase();

                    if (
                      historia[`codigoCIEDiagnostico${num}`] &&
                      value !== diagnosticoBusqueda[num]
                    ) {
                      setHistoria({
                        ...historia,
                        [`codigoCIEDiagnostico${num}`]: "",
                        [`confirmacionDiagnostica${num}`]: null
                      });

                      setDiagnosticosSeleccionados((prev) => ({
                        ...prev,
                        [num]: null
                      }));

                      setDiagnosticoBusqueda((prev) => ({
                        ...prev,
                        [num]: ""
                      }));

                      setDiagnosticosCatalogo([]);
                      setCieActivo(num);
                      return;                    }

                    setDiagnosticoBusqueda((prev) => ({
                      ...prev,
                      [num]: value
                    }));
                    setCieActivo(num);
                  }}
              onBlur={() => {
                  

                      if (!historia[`codigoCIEDiagnostico${num}`]) {
                        setDiagnosticoBusqueda((prev) => ({ ...prev, [num]: "" }));
                      }
                    
                  }}
                />

                {cieActivo === num && diagnosticosCatalogo.length > 0 && (
                  <div className="cie-dropdown">
                    {diagnosticosCatalogo.map((dx) => (
                      <div
                        key={`${num}-${dx.CATALOG_KEY}`}
                        className="cie-option"
                        onMouseDown={(e) => {
                          e.preventDefault();                     
                          const otrosCodigos = cieFields
                            .filter((n) => n !== num)
                            .map((n) => historia[`codigoCIEDiagnostico${n}`])
                            .filter(Boolean);

                        if (otrosCodigos.includes(dx.CATALOG_KEY) && dx.CATALOG_KEY !== "R69X") {
                              toast.warning("Este diagnóstico ya fue registrado. Seleccione uno diferente.");
                              
                              return;
                            }

                          setHistoria((prev) => ({
                            ...prev,
                            [`codigoCIEDiagnostico${num}`]: dx.CATALOG_KEY
                          }));
                          setDiagnosticosSeleccionados((prev) => ({
                            ...prev,
                            [num]: dx
                          }));

                        const nombreCieLimpio = String(dx.NOMBRE || "").replace(/\s+/g, " ").trim();

                          setDiagnosticoBusqueda((prev) => ({
                            ...prev,
                            [num]: `${nombreCieLimpio} - ${dx.CATALOG_KEY}`
                          }));

                          setDiagnosticosCatalogo([]);
                          setCieActivo(num);
                          
                        }}
                      >
                        {dx.NOMBRE} - {dx.CATALOG_KEY}
                      </div>
                    ))}
                  </div>
                )}
              </div>

                            <div style={{ display: "flex", gap: 4 }}>
                <button
                  type="button"
                  className="tab"
                  onClick={() => eliminarCampoCIE(num)}
                  disabled={cieFields.length === 1}
                >
                  –
                </button>
                <button
                  type="button"
                  className="tab"
                  onClick={agregarCampoCIE}
                  disabled={cieFields.length === 3}
                >
                  +
                </button>
              </div>
            </div>

            {(() => {
              const dx = diagnosticosSeleccionados[num];
              const esPrimeraVez = num === 1
                ? String(historia.relacionTemporal).trim() === "0"
                : historia[`primeraVezDiagnostico${num}`] === 1;

              if (!aplicaConfirmacionDiagnostica(dx, edadPaciente, esPrimeraVez)) return null;

              return (
                <div key={`conf-${num}`} className="subrubro" style={{ marginTop: 8 }}>
                  <label>
                    ¿Se confirma el diagnóstico {num} ({historia[`codigoCIEDiagnostico${num}`]})?
                  </label>
                  <select
                    name={`confirmacionDiagnostica${num}`}
                    value={historia[`confirmacionDiagnostica${num}`] ?? ""}
                    onChange={(e) =>
                      setHistoria((prev) => ({
                        ...prev,
                        [`confirmacionDiagnostica${num}`]:
                          e.target.value === "" ? null : Number(e.target.value)
                      }))
                    }
                  >
                    <option value="">Seleccione</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                  </select>
                </div>
              );
            })()}
          </div>
        ))}

          
          
           </>
          )}
         
           <CampoAsistido
            tipo="textarea"
            campo="diagnosticos"
            name="diagnosticos"
            placeholder="Describa los diagnósticos"
            value={historia.diagnosticos || ""}
            onChange={handleChange}
            sugerenciasHistoricasHabilitadas={sugerenciasHistoricasHabilitadas}
            buscarSugerenciasHistoricas={getSugerenciasHistoricasExpediente}
            onOcultarSugerenciaHistorica={onOcultarSugerenciaHistorica}
          />
     
          {/* Pronóstico */}
          <h3>Pronóstico</h3>
          <CampoAsistido
              tipo="textarea"
              campo="pronostico"
              name="pronostico"
              placeholder="Describa el pronóstico"
              value={historia.pronostico || ""}
              onChange={handleChange}
              plantillasHabilitadas={plantillasHabilitadas}
              plantillasPersonalizadas={plantillasPersonalizadas}
            />

        {/* Plan de tratamiento */}
        <h3>Plan de Tratamiento</h3>
        {/* Intervenciones de Salud Mental y Adicciones */}
        {nom024 && (
        <div className="subrubro" style={{ marginTop: "12px" }}>
          <label>Intervenciones de Salud Mental y Adicciones</label>
          <select
            name="intervencionesSMyA"
            value={historia.intervencionesSMyA ?? "-1"}
            onChange={handleChange}
          >
            <option value="-1">Seleccione</option>
            <option value="1">Intervención psicosocial</option>
            <option value="2">Tratamiento farmacológico</option>
            <option value="3">Ambos</option>
          </select>
        </div>
        )}
          {/* Medicamentos (JSON estructurado) */}
           <label>Tratamiento</label>
            {medicamentos.map((item, idx) => (
              <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 8, marginBottom: 8 }}>
                <CampoAsistido
                  campo="medicamentos"
                  placeholder="Medicamento (p. ej., Paracetamol 500 mg)"
                  value={item.nombre || ""}
                  onChange={(e) => {
                    const v = e.target.value;

                    setMedicamentos(prev =>
                      prev.map((m, i) =>
                        i === idx ? { ...m, nombre: v } : m
                      )
                    );
                  }}
                  sugerenciasHistoricasHabilitadas={sugerenciasHistoricasHabilitadas}
                  buscarSugerenciasHistoricas={getSugerenciasHistoricasExpediente}
                  onOcultarSugerenciaHistorica={onOcultarSugerenciaHistorica}
                />
                <CampoAsistido
                  campo="posologia"
                  placeholder="Indicaciones (dosis, frecuencia, duración)"
                  value={item.indicaciones || ""}
                  onChange={(e) => {
                    const v = e.target.value;

                    setMedicamentos(prev =>
                      prev.map((m, i) =>
                        i === idx ? { ...m, indicaciones: v } : m
                      )
                    );
                  }}
                  sugerenciasHistoricasHabilitadas={sugerenciasHistoricasHabilitadas}
                  buscarSugerenciasHistoricas={getSugerenciasHistoricasExpediente}
                  onOcultarSugerenciaHistorica={onOcultarSugerenciaHistorica}
                />
                <div style={{ display: "flex", gap: 4 }}>
                  <button type="button" className="tab" onClick={() => setMedicamentos(prev => prev.filter((_, i) => i !== idx))} disabled={medicamentos.length === 1}>–</button>
                  <button type="button" className="tab" onClick={() => setMedicamentos(prev => [...prev, { nombre: "", indicaciones: "" }])}>+</button>
                </div>
              </div>
            ))}

 
          {/* Plan de tratamiento */}
        <label>Plan</label>
          <CampoAsistido
            tipo="textarea"
            campo="planTratamiento"
            name="planTratamiento"
            placeholder="Describa el plan (laboratorios, recomendaciones generales)"
            value={historia.planTratamiento || ""}
            onChange={handleChange}
            plantillasHabilitadas={plantillasHabilitadas}
            plantillasPersonalizadas={plantillasPersonalizadas}
          />
        
          {/* Indicaciones adicionales */}
          <h3>Indicaciones Adicionales</h3>
          <textarea
            name="indicacionesAdicionales"
            placeholder="Describa las indicaciones adicionales"
            value={historia.indicacionesAdicionales}
            onChange={handleChange}
          ></textarea>
        </div>
      </Accordion>
        <CuestionarioPorEspecialidadHistoria
          especialidadMedico={especialidadHistoria}
          historia={historia}
          setHistoria={setHistoria}
          openRubros={openRubros}
          toggleRubro={toggleRubro}
          selectedKeys={selectedKeys}
          nom024={nom024}
          edadPaciente={edadPaciente}
          edadMesesPaciente={edadMesesPaciente}
          sexo={sexo}
          fechaNacimiento={fechaNacimiento}
        />
      </>
  );
}